import { makeStyles } from '@material-ui/core';
import { RefObject, useState } from 'react';
import { Handle, Position } from 'reactflow';
import { usePrototypeInformationGraphContext } from '../../../../../PrototypeInformationGraphContext';
import { ComponentAccordion } from '../../../../../components/ComponentAccordion';
import { SubComponent } from '../../../../../components/SubComponent';
import { VisibilityChecker } from '../../../../../components/VisibilityChecker';
import { DataSource as DataSourceType } from '../../../../../types';

type DataSourceProps = {
  name: string;
  parentRef: RefObject<HTMLDivElement>;
  dataSources: DataSourceType[];
};

const useStyles = makeStyles(
  () => ({
    root: {
      background: 'transparent',
      position: 'relative',
    },
    visibilityChecker: {
      position: 'absolute',
      top: 18,
      right: 0,
    },
    content: {
      flexDirection: 'column',
      display: 'flex',
      gap: '10px',
    },
  }),
  { name: 'DataSource' },
);

export const DataSource = ({
  name,
  parentRef,
  dataSources,
}: DataSourceProps) => {
  const classes = useStyles();

  const { setVisibleDataSources } = usePrototypeInformationGraphContext();

  const [expanded, setExpanded] = useState(true);

  return (
    <ComponentAccordion
      label={name}
      expanded={expanded}
      handleChange={() => setExpanded(old => !old)}
      visibilityChecker={
        <VisibilityChecker
          className={classes.visibilityChecker}
          id={name}
          setVisibleIds={setVisibleDataSources}
          parentRef={parentRef}
        />
      }
      handle={
        <Handle
          type="target"
          id={name}
          position={Position.Right}
          style={{
            top: 20,
            right: '-5px',
            visibility: 'hidden',
          }}
        />
      }
    >
      {dataSources.map(d => (
        <SubComponent key={d.name} label={d.name} />
      ))}
    </ComponentAccordion>
  );
};
